import React, { useState, useEffect, useRef } from "react";
import { gl_start, registerSceneHMR, setUniform } from "./webgl0.js";

function Scene() {
this.vertexShader = `#version 300 es
in vec3 aPos;
out vec3 vPos;

void main() {
  gl_Position = vec4(aPos, 1.0);
  vPos = aPos;
}`;

this.fragmentShader = `#version 300 es
precision highp float;
uniform float uTime;
in  vec3 vPos;
out vec4 fragColor;
void main() {
   fragColor = vec4(0.);
   vec3 ambient = vec3(.2,.1,.05);
   float zMax = -1000.;
   vec3 L1 = normalize(vec3(sin(2. * uTime), 1., 0.));
   vec3 L2 = normalize(vec3(-1.,-.1,0.));
   for (int i = 0 ; i < 50 ; i++) {
      float fi = float(i);
      vec3 color = vec3(.5 + .5 * sin(fi),
                        .5 + .5 * sin(4.*fi),
                        .5 + .5 * sin(5.*fi));
      float vx = vPos.x;
      float vy = vPos.y;
      //vx += .2 * sin(5. * vy + 3. * uTime);
      //vy += .2 * sin(5. * vx + 1. * uTime);
      float x = 8. * vx + 4. * sin(11.8 * fi + 100.3 + .3 * uTime);
      float y = 8. * vy + 4. * sin(10.3 * fi + 200.6 + .3 * uTime);
      float z = 8. * vy + 4. * cos(10.3 * fi + 200.6 + .3 * uTime);
      float rr = 1. - x*x - y*y;
      z += rr / (8.*8.);
      if (rr > 0. && z > zMax) {
         zMax = z;
         float z = sqrt(rr);
         float D1 = dot(vec3(x,y,z),L1);
         float D2 = dot(vec3(x,y,z),L2);
	 D1 = .4 * max(0., D1 * abs(D1));
	 D2 = .4 * max(0., D2 * abs(D2));
         vec3 diffuse = D1 * vec3(.2,.5,1.) +
                        D2 * vec3(.2,.5,1.) ;
         fragColor = vec4(sqrt(color * (ambient + diffuse)), 1.);
      }
   }
}`;

  let startTime = Date.now() / 1000;

  this.update = () => {
    setUniform('1f', 'uTime', Date.now() / 1000 - startTime);
  };
}

export default function WebGLCanvas() {
  const canvasRef = useRef(null);
  const [scene, setScene] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {}

    const newScene = new Scene();

    gl_start(canvas, newScene);
    setScene(newScene);

    try { registerSceneHMR(module, canvas, () => new Scene()); } catch (e) { /* ignore in non-HMR env */ }
    return () => { try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {} };
  }, []);

  return (
    <div style = { { display: "flex", justifyContent: "center", gap : "16px" } }>
        <canvas ref={canvasRef} width={400} height={400} style={{ width : "400px", height : "400px", display: "block", margin: "0 auto", background: "#f6f6f6" }} />
        <pre>{ scene?.fragmentShader }</pre>
    </div>
  );
}
